import { render, staticRenderFns } from "./VFilterModal.vue?vue&type=template&id=8b37bf72&"
import script from "./VFilterModal.vue?vue&type=script&lang=js&"
export * from "./VFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports